module.exports = __webpack_public_path__ + "img/Main_grid_square_6.8b25762d.jpg";